import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import EtapaForm from '../EtapaForm';

function EtapaEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <EtapaForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </EtapaForm>
    </Edit>
  );
}

export default EtapaEdit;
